module.exports = __webpack_public_path__ + "static/easymailer-dashboard-6996d28b59195465478e2c244ca5b350.png";